import PropTypes from 'prop-types';
import React from 'react';
import styles from './logo.module.scss';

class LogoSvg extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.string,
    color: PropTypes.string,
    height: PropTypes.string,
    viewBox: PropTypes.string,
    url: PropTypes.string,
  };

  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {
      placeholder:
        'M160.14,229.41H13.76a6.32,6.32,0,0,1-6.31-6.31V180.2a6.31,6.31,0,0,1,6.' +
        '31-6.31H160.14a13.88,13.88,0,1,0-.21-27.76H13.76a6.32,6.32,0,0,1-6.31-6.31V13.63a6.' +
        '32,6.32,0,0,1,6.31-6.31H140a6.32,6.32,0,0,1,6.31,6.31V56.54a6.31,6.31,0,0,1-6.31,6.3H69' +
        '.28A6.32,6.32,0,0,0,63,69.15V84.3a6.32,6.32,0,0,0,6.31,6.31H159.6c38.31,0,70.08,31.34,69.94,' +
        '69.65A69.4,69.4,0,0,1,160.14,229.41ZM174,15V58.51a6.29,6.29,0,0,0,5.06,6.18A97.21,97.21,0,0,1,' +
        '257.3,159.6c.22,53.91-43.84,97.57-97.76,97.57H13.76a6.31,6.31,0,0,0-6.31,6.31v42.' +
        '9a6.31,6.31,0,0,0,6.31,6.31H159.45c84.21,0,153.06-67.9,153.37-152.12A152.7,152.7,0,0,0,181.2,8.' +
        '77,6.31,6.31,0,0,0,174,15Z',
      svg: null,
    };
  }

  render() {
    const {height = '1em', width = '25px', color = 'white', url, viewBox = '0 0 300 300'} = this.props;

    const {placeholder} = this.state;

    return (
      <svg className={styles.logoSvg} focusable='false' height={height} width={width} viewBox={viewBox} fill={color}>
        {url ? <image href={url} height={'100%'} /> : <path d={placeholder} transform='translate(-7.45 -7.32)' />}
      </svg>
    );
  }
}

export default LogoSvg;
